import React from "react";
import {
  ROUTE_LOGIN,
  ROUTE_ROOT,
  ROUTE_SIGNUP,
  ROUTE_OTP,
  ROUTE_CLASSROOM,
  ROUTE_EDUCENTRE,
  ROUTE_NOTES,
  ROUTE_PROFILE,
  ROUTE_CLASSROOM_DETAIL,
  ROUTE_PROFILE_EDIT,
  ROUTE_NOTES_MATERIAL,
  ROUTE_NOTES_RECORDINGS,
  ROUTE_NOTES_ASSIGNMENTS,
  ROUTE_NOTES_WRITTEN_NOTES,
  ROUTE_ASSIGNMENTS,
  ROUTE_VIEW_ALL_CLASSROOM_PENDING,
  ROUTE_VIEW_ALL_CLASSROOM_UPCOMING,
  ROUTE_VIEW_ALL_CLASSROOM_RECORDINGS,
  ROUTE_EDUCENTRE_DETAIL,
  ROUTE_EDUCENTRE_COURSES,
  ROUTE_NOTIFICATIONS,
  ROUTE_PAYMENTS,
} from "../constant/routes";
import { createBrowserRouter } from "react-router-dom";
import Dashboard from "../pages/Dashboard";
import Classroom from "../pages/Classroom";
import Educentre from "../pages/Educentre";
import Notes from "../pages/Notes";
import Profile from "../pages/Profile";
import SignIn from "../pages/Auth/SignIn";
import SignUp from "../pages/Auth/SignUp";
import Otp from "../pages/Auth/Otp";
import App from "./App.jsx";
import ProtectedRoute from "./ProtectedRoute.jsx";
import ClassroomDetail from "../pages/Classroom/component/ClassroomDetail.jsx";
import EditProfile from "../pages/Profile/component/EditProfile.jsx";
import WrittenNotes from "../pages/Notes/component/WrittenNotes.jsx";
import NotesMaterial from "../pages/Notes/component/NotesMaterial.jsx";
import Recordings from "../pages/Notes/component/Recordings.jsx";
import Assignments from "../pages/Notes/component/Assignments.jsx";
import ViewAllAssignment from "../pages/Dashboard/components/ViewAllAssignment.jsx";
import Fallback from "../component/Fallback/Fallback.jsx";
import PendingAll from "../pages/Classroom/component/PendingAll.jsx";
import UpcomingAll from "../pages/Classroom/component/UpcomingAll.jsx";
import RecordingAll from "../pages/Classroom/component/RecordingAll.jsx";
import EducentreDetails from "../pages/Educentre/components/EducentreDetails.jsx";
import EducentreCoaching from "../pages/Educentre/components/EducentreCoaching.jsx";
import Notification from "../pages/Notification/Notification.jsx";
import Payments from "../pages/Profile/component/Payments.jsx";

export const router = createBrowserRouter(
  [
    {
      element: <App />,
      errorElement: <Fallback />,
      children: [
        {
          path: ROUTE_LOGIN,
          element: <SignIn />,
        },
        {
          path: ROUTE_SIGNUP,
          element: <SignUp />,
        },
        {
          path: ROUTE_OTP,
          element: <Otp />,
        },
      ],
    },
    {
      element: <ProtectedRoute />,
      errorElement: <Fallback />,
      children: [
        {
          path: ROUTE_ROOT,
          element: <Dashboard />,
        },
        {
          path: ROUTE_CLASSROOM,
          element: <Classroom />,
        },
        {
          path: ROUTE_CLASSROOM_DETAIL,
          element: <ClassroomDetail />,
        },
        {
          path: ROUTE_EDUCENTRE,
          element: <Educentre />,
        },
        {
          path: ROUTE_NOTES,
          element: <Notes />,
        },
        {
          path: ROUTE_NOTES_MATERIAL,
          element: <NotesMaterial />,
        },
        {
          path: ROUTE_NOTES_WRITTEN_NOTES,
          element: <WrittenNotes />,
        },
        {
          path: ROUTE_NOTES_RECORDINGS,
          element: <Recordings />,
        },
        {
          path: ROUTE_NOTES_ASSIGNMENTS,
          element: <Assignments />,
        },
        {
          path: ROUTE_PROFILE,
          element: <Profile />,
        },
        {
          path: ROUTE_PROFILE_EDIT,
          element: <EditProfile />,
        },
        {
          path: ROUTE_ASSIGNMENTS,
          element: <ViewAllAssignment />,
        },
        {
          path: ROUTE_VIEW_ALL_CLASSROOM_PENDING,
          element: <PendingAll />,
        },
        {
          path: ROUTE_VIEW_ALL_CLASSROOM_UPCOMING,
          element: <UpcomingAll />,
        },
        {
          path: ROUTE_VIEW_ALL_CLASSROOM_RECORDINGS,
          element: <RecordingAll />,
        },
        {
          path: ROUTE_EDUCENTRE_DETAIL,
          element: <EducentreDetails />,
        },
        {
          path: ROUTE_EDUCENTRE_COURSES,
          element: <EducentreCoaching />,
        },
        {
          path: ROUTE_NOTIFICATIONS,
          element: <Notification />,
        },
        {
          path: ROUTE_PAYMENTS,
          element: <Payments />,
        },
      ],
    },
  ]
  // { basename: "/" }
);
